// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const mew: PokeData = {
  "id": 151,
  "name": "mew",
  "height": 4,
  "weight": 40,
  "base_experience": 270,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "pound",
    "mega-punch",
    "confusion",
    "psychic",
    "mimic",
    "barrier",
    "metronome",
    "swift",
    "amnesia",
    "transform",
    "psywave",
    "baton-pass",
    "ancient-power",
    "imprison",
    "me-first",
    "aura-sphere",
    "nasty-plot",
    "reflect-type",
    "life-dew"
  ],
  "moves": [
    "psychic",
    "psywave",
    "ancient-power",
    "life-dew",
    "calm-mind",
    "prismatic-cage",
    "reflect",
    "psychic-terrain",
    "healing-wish",
    "future-sight",
    "synchronize",
    "psychic-fangs",
    "kinesis"
  ],
  "evolution_chain": {
    "id": 78,
    "item": null,
    "species": [
      {
        "name": "mew",
        "order": 183,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 133,
    "ability_power": 133
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
